const RENTALS_ATTRIBUTES = {
  //getPropertyAttributes
  RENTALS_PROPERTY_ATTRIBUTES: 'RENTALS_PROPERTY_ATTRIBUTES',
  //getPropertyAttributesTranslations
  RENTALS_PROPERTY_ATTRIBUTES_TRANSLATIONS: 'RENTALS_PROPERTY_ATTRIBUTES_TRANSLATIONS',
};

export default RENTALS_ATTRIBUTES;
